import React, { PureComponent } from 'react';
import ShortId from 'shortid';

const ESC_ENTER = 27;

function WithEscNavigation(Component) {
  return class EscNavigation extends PureComponent {
    state = {
      key: ShortId.generate(),
      inputValue: null,
      withQuickSearchFilter: {}
    };

    withEscNavigationCallback = (callback) => {
      this.setState({
        callback
      });
    };

    async componentDidMount() {
      window.addEventListener('keydown', this.escListener);
    }

    componentWillUnmount() {
      window.removeEventListener('keydown', this.escListener);
    }

    escListener = event => {
      const { callback } = this.state;

      var isEscape = false;
      if ('key' in event) {
        isEscape = event.key === 'Escape' || event.key === 'Esc';
      } else {
        isEscape = event.keyCode === ESC_ENTER;
      }
      if (isEscape) {
        callback();
      }
    };

    render() {
      return (
        <Component
          {...this.props}
          withEscNavigationCallback={this.withEscNavigationCallback}
        />
      );
    }
  };
}

export default WithEscNavigation;
